class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {
 const dndPromotion = window.libraryMainsite.promotion;
    let globalCount;
    async function animationRandom(count, elementResult) {
        const listItem = $('.gr_effect--item');
        const n = listItem.length;

        // Vị trí ô trúng thưởng trong danh sách
        let resultIndex = 0;
        listItem.each(function (i) {
            if ($(this).data('stt') === parseInt(elementResult)) resultIndex = i;
        });

        // Chạy TUẦN TỰ 2 vòng rồi dừng đúng ô kết quả (mượt như vòng quay)
        const loops = 2;
        const totalSteps = n * loops + resultIndex;

        for (let step = 0; step <= totalSteps; step++) {
            listItem.removeClass('active');
            $(listItem[step % n]).removeClass('MS__off').addClass('active');

            // Tốc độ: tick nhanh lúc đầu, chậm dần về cuối cho mượt (ease-out).
            // Chỉnh 2 số dưới để nhanh/chậm hơn: base (ms đầu) + range (ms cộng thêm cuối).
            const t = step / totalSteps;        // 0 -> 1
            const delay = 40 + 120 * (t * t);   // ~40ms (đầu) -> ~160ms (cuối)

            await new Core().wait(delay);
        }
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 2500,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            animationRandom(10, prizeIndex);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
            globalCount = 10;
            $('.gr_effect--item').removeClass('active');
            // $('.gr_effect--item').addClass('MS__off');
            $('.gr_effect--item').removeClass('MS__off');
        },
    })
   
});
